import React from 'react';

import { useCurrentTheme } from 'app/shared/theme';
import { Typography, ZendeskLink } from 'app/shared/components/atoms';
import { MappingsProps } from 'app/fan/components/templates/EventPage/components/EventCharacteristicsList/utils';
import { ReactComponent as Chair } from 'icons/chair-1.svg';
import { ReactComponent as PartyMusicDance } from 'icons/standing-room.svg';
import { ReactComponent as YogaMeditate } from 'icons/yoga.svg';

export function useSeatingTypeMappings({ formatMessage }: MappingsProps) {
  const { colors } = useCurrentTheme();
  const intlPrefix = 'event.eventCharacteristicsList.seatingType';
  const id = 'seating';

  return {
    unknown: {
      id,
      icon: YogaMeditate,
      iconFillColor: colors.accent.primaryAccent.base,
      title: formatMessage({ id: `${intlPrefix}.unknown` }),
      details: (
        <Typography color={colors.primary.white.base}>
          {formatMessage(
            { id: `${intlPrefix}.unknown.details` },
            {
              a: (chunks) => <ZendeskLink>{chunks}</ZendeskLink>,
            }
          )}
        </Typography>
      ),
    },
    no_chairs: {
      id,
      icon: YogaMeditate,
      iconFillColor: colors.accent.primaryAccent.base,
      title: formatMessage({ id: `${intlPrefix}.noChairs` }),
      details: (
        <Typography color={colors.primary.white.base}>
          {formatMessage(
            { id: `${intlPrefix}.noChairs.details` },
            {
              a: (chunks) => <ZendeskLink>{chunks}</ZendeskLink>,
            }
          )}
        </Typography>
      ),
    },
    some_chairs: {
      id,
      icon: YogaMeditate,
      iconFillColor: colors.accent.primaryAccent.base,
      title: formatMessage({ id: `${intlPrefix}.someChairsAvailable` }),
      details: (
        <Typography color={colors.primary.white.base}>
          {formatMessage(
            {
              id: `${intlPrefix}.someChairsAvailable.details`,
            },
            {
              a: (chunks) => <ZendeskLink>{chunks}</ZendeskLink>,
            }
          )}
        </Typography>
      ),
    },
    chairs_available: {
      id,
      icon: Chair,
      title: formatMessage({ id: `${intlPrefix}.chairsAvailable` }),
      details: (
        <Typography color={colors.primary.white.base}>
          {formatMessage({ id: `${intlPrefix}.chairsAvailable.details` })}
        </Typography>
      ),
    },
    chairs_built_in: {
      id,
      icon: Chair,
      title: formatMessage({ id: `${intlPrefix}.chairsBuiltIn` }),
      details: (
        <Typography color={colors.primary.white.base}>
          {formatMessage({ id: `${intlPrefix}.chairsBuiltIn.details` })}
        </Typography>
      ),
    },
    standing_room: {
      id,
      icon: PartyMusicDance,
      iconFillColor: colors.accent.primaryAccent.base,
      title: formatMessage({ id: `${intlPrefix}.standingRoom` }),
      details: (
        <Typography color={colors.primary.white.base}>
          {formatMessage(
            {
              id: `${intlPrefix}.standingRoom.details`,
            },
            {
              a: (chunks) => <ZendeskLink>{chunks}</ZendeskLink>,
            }
          )}
        </Typography>
      ),
    },
  };
}
